module.exports = __webpack_public_path__ + "static/Carly_Daniel6-497f75f2d1a2382e6d49bfc28b3a3446.jpg";